import React, { HTMLAttributes, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

interface SectionProps extends HTMLAttributes<HTMLDivElement> {}

export const Section = forwardRef(
  ({ children, className, ...rest }: SectionProps, ref: any) => {
    const _className = twMerge('py-8 xl:py-12', className)

    return (
      <section className={_className} ref={ref} {...rest}>
        {children}
      </section>
    )
  },
)

Section.displayName = 'Section'
